export default __webpack_public_path__ + "static/media/Cloudticity Logo_color.826f8201.svg";